import moment from 'moment';
const baseState = {
    numberOfRecipients: '',
    deliveryDate: moment().add(5, 'days').format('YYYY-MM-DD'),
    companyName: '',
    organizationNumber: '',
    contactPersonName: '',
    contactPersonEmail: '',
    contactPersonPhone: '',
    comment: '',
    billingEmail: '',
    selectedProduct: null,
    showCapacityWarning: false,
    heroImage: '',
    customerQuotes: [],
    featuredProducts: [],
    orderType: 'PRODUCT',
    regionId: null,
    regionSlug: null,
    giftCardAmount: '100',
};
export default function reducer(state = baseState, action) {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case 'B2B/SET_NUMBER_OF_RECIPIENTS':
            return Object.assign(Object.assign({}, state), { numberOfRecipients: action.payload });
        case 'B2B/SET_DELIVERY_DATE':
            return Object.assign(Object.assign({}, state), { deliveryDate: action.payload });
        case 'B2B/SET_COMPANY_NAME':
            return Object.assign(Object.assign({}, state), { companyName: action.payload });
        case 'B2B/SET_ORGANIZATION_NUMBER':
            return Object.assign(Object.assign({}, state), { organizationNumber: action.payload });
        case 'B2B/SET_CONTACT_PERSON_NAME':
            return Object.assign(Object.assign({}, state), { contactPersonName: action.payload });
        case 'B2B/SET_CONTACT_PERSON_EMAIL':
            return Object.assign(Object.assign({}, state), { contactPersonEmail: action.payload });
        case 'B2B/SET_CONTACT_PERSON_PHONE':
            return Object.assign(Object.assign({}, state), { contactPersonPhone: action.payload });
        case 'B2B/SET_COMMENT':
            return Object.assign(Object.assign({}, state), { comment: action.payload });
        case 'B2B/SET_BILLING_EMAIL':
            return Object.assign(Object.assign({}, state), { billingEmail: action.payload });
        case 'B2B/SET_SELECTED_PRODUCT':
            return Object.assign(Object.assign({}, state), { selectedProduct: action.payload });
        case 'B2B/SET_GIFTCARD_AMOUNT':
            return Object.assign(Object.assign({}, state), { giftCardAmount: action.payload });
        case 'B2B/SET_ORDER_TYPE':
            return Object.assign(Object.assign({}, state), { orderType: action.payload });
        case 'B2B/FETCH_LANDING_PAGE_SUCCESS': {
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { showCapacityWarning: payload.showCapacityWarning, customerQuotes: payload.customerQuotes, heroImage: payload.heroImage, featuredProducts: payload.featuredProducts });
        }
        case 'B2B/SET_REGION': {
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { regionId: payload.regionId, regionSlug: payload.regionSlug });
        }
        default:
            return state;
    }
}
